export default[
    {
        path: '/ferias/lista',
        name: 'lista das ferias', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/ferias/cadastro',
        name: 'cadastro das ferias', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/ferias/editar/:id',
        name: 'editar ferias', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]
